export const AUTH_SUCCESS = "AUTH_SUCCESS"
export const LOGOUT = "LOGOUT"
export const TOGGLE_LOADER = "TOGGLE_LOADER"
export const UPDATE_AUTH_TOKEN = "UPDATE_AUTH_TOKEN"
export const UPDATE_POLICY = "UPDATE_POLICY"